import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtherService from "../../services/Other";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { formatNumber } from "../../constants/commonFunction";
import { FaStar } from "react-icons/fa";
import TierCardNew from "../../component/TierCardNew";
import awardSymbol from "../../assets/images/awardSymbol.png";
import awardCup from "../../assets/images/cup.png";
import { addUserPersona } from "../../redux/slices/currentUserSlice";
import BigBox from "../BigBox.js";
import { fetchPdf } from "../../constants/commonFunction";

const SummaryBoard = ({ hierName, showPoints }) => {
  const dispatch = useDispatch();
  const [pointDetails, setPointDetails] = useState(null);
  const isUserAllInfo = useSelector(
    (state) => state.userTypeSlice.personalInfoResponse?.response?.message
  );
  const detailedPointsRes = useSelector(
    (state) => state.detailedPoints.detailedPoints
  );
  const detailedPoints = detailedPointsRes?.success
    ? detailedPointsRes.response || {}
    : {};
  const [userInfo, setUserInfo] = useState(null);
  const [insuranceData, setInsuranceData] = useState(null);
  const [pdfLink, setPdfLink] = useState("");
  const userInformation = JSON.parse(localStorage.getItem("userData"));
  const conId = userInformation.dcm_contacts_id;

  const getPoints = async () => {
    try {
      const res = await OtherService.myPointsNew();
      // const res = await OtherService.getProfile(conId)
      if (res.success) {
        setPointDetails(res.response.pointDetails);
      }
    } catch (error) {
      console.error("getPoints API error");
    }
  };

  useEffect(() => {
    // getPoints();
  }, []);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    dispatch(addUserPersona({ userPersona: userInfo.description }));
    setUserInfo(userInfo);
  }, []);

  // const fetchInsuranceData = async() => {
  //   try {
  //       const res = await ProfileService.getInsuranceData(userInformation.dcm_contacts_id);

  //       if(res.success) {
  //           setInsuranceData(res.data[0]);
  //           fetchPdf(res.data[0].insurance_docs).then(link => {

  //               setPdfLink(link)
  //           })
  //       }
  //   } catch (error) {
  //       console.error("ProfileDataFetch Error");
  //   }
  // };

  // useEffect(() => {
  //   fetchInsuranceData();
  // }, []);

  return (
    <>
    <div className="tierCardBox" style={{margin:0, padding:"20px",width:"100%", height:"100%"}}>
      <TierCardNew
        tierStar={awardSymbol}
        awardCup={awardCup}
        totalPoints={isUserAllInfo?.totalPoints}
        redemPoints={isUserAllInfo?.getRedemPoints}
        availablePoints={isUserAllInfo?.availablePoints}
        // nextTarget={isPointInfo.availablePoints}
        tierName={isUserAllInfo?.tierName}
      />
    </div>
    </>
  );
};

export default SummaryBoard;
